import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import moduleAuth from './auth/moduleAuth.js'
import moduleTree from './tree/moduleTree.js'
import moduleChat from './chat/moduleChat.js'
import moduleUsers from './users/moduleUsers.js'
import moduleField from './taskfield/moduleTaskField.js'
import moduleMisc from './misc/moduleMisc'
import moduleInjector from './injector/moduleInjector'
import moduleInstance from './instance/moduleInstance'
import moduleCondition from './taskcondition/moduleTaskCondition.js'
import modulePositions from './positions/modulePositions.js'
import moduleSystem from './system/moduleSystem.js'
import moduleTimeLog from './timelog/moduleTimeLog'
import moduleTaskUsers from './taskusers/moduleTaskUsers'
import moduleTaskTags from './tasktags/moduleTaskTags'
import moduleNotifications from './notifications/moduleNotifications'
import moduleTFInstance from './taskfieldinstance/moduleTaskFieldInstance'
import moduleTFValue from './taskfieldvalue/moduleTaskFieldValue'
import moduleTimeInjectors from './task-injectors/time-injector/moduleTimeInjectors'
import moduleMessenger from './messenger/moduleMessenger'
import moduleWsu from './wsusers/moduleWsUsers'
import moduleWsp from './wspositions/moduleWsPositions'
import moduleContent from './content/moduleContent'
import moduleKPIs from './nodekpis/moduleNodeKpis'
import moduleNodeAttributes from './nodeattributes/moduleNodeAttributes'
import moduleNodeTriggers from './node-triggers/moduleNodeTriggers'
import moduleRoadmap from './roadmap/moduleRoadmap'

Vue.use(Vuex);


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        auth: moduleAuth,
        tree: moduleTree,
        users: moduleUsers,
        taskfields: moduleField,
        taskconditions: moduleCondition,
        instances: moduleInstance,
        tfinstances: moduleTFInstance,
        injectors: moduleInjector,
        chat: moduleChat,
        messenger: moduleMessenger,
        positions: modulePositions,
        system: moduleSystem,
        taskuser: moduleTaskUsers,
        tasktag: moduleTaskTags,
        misc: moduleMisc,
        timelog: moduleTimeLog,
        notifications: moduleNotifications,
        tfvalues: moduleTFValue,
        wsusers: moduleWsu,
        wspositions: moduleWsp,
        content: moduleContent,
        kpi: moduleKPIs,
        nodeattr: moduleNodeAttributes,
        timeInjectors: moduleTimeInjectors,
        triggers: moduleNodeTriggers,
        roadmap: moduleRoadmap
    },
    strict: false//process.env.NODE_ENV !== 'production'
})
